var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 35,
    viewBox: "0 0 48 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8912 28.9418C45.1662 24.2338 48.1523 11.292 39.2196 5.10347C27.5676 -2.96909 12.091 13.1839 6.20563 25.4086",
    stroke: "black",
    strokeWidth: 4.49678,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21752 25.4806C4.90808 22.2835 2.50409 14.4837 3.3636 8.86097",
    stroke: "black",
    strokeWidth: 4.49678,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21737 25.4806C9.66758 25.3016 17.9275 24.694 22.6468 21.5187",
    stroke: "black",
    strokeWidth: 4.49678,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousIcon);
export default __webpack_public_path__ + "static/media/previous-icon.c473f3ddb42eac940fd66e38ca59eb93.svg";
export { ForwardRef as ReactComponent };